import './styles/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Providers from './hooks/Providers';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../node_modules/jquery-mask-plugin/dist/jquery.mask';

ReactDOM.render(
  <Providers>
    <App />
  </Providers>,
  document.getElementById('root')
);
